import { GET_ALL_LEDGER_BALANCE } from '../../../constants/asyncActionsType'
import createAsyncThunkForSlice from '../../../utils/utils'
import { getAllLedgerBalanceList } from './ledgerCrud'

export const getAllLedgerBalance = createAsyncThunkForSlice(
  GET_ALL_LEDGER_BALANCE,
  getAllLedgerBalanceList
)
